import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './eiuov-ui/utils/drag'

import 'nprogress/nprogress.css'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor, /* { default global options } */)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/scss/element-variables.scss'
Vue.use(ElementUI,{size:'big'});

/* ei ui 插件 */
import './eiuov-ui/index'
import "./eiuov-ui/css/eiuov-ui.css"
/*  挂载 */
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.prototype.$notify = ElementUI.Notification


Vue.config.productionTip = false
let vm=new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
